module.exports = __webpack_public_path__ + "img/file-attachment-01.21cd614a.svg";